export default __webpack_public_path__ + "static/media/vehicle_suv.d8a9faca.svg";